import { render, staticRenderFns } from "./UserControlPreferences.vue?vue&type=template&id=e8b588ec"
import script from "./UserControlPreferences.vue?vue&type=script&lang=js"
export * from "./UserControlPreferences.vue?vue&type=script&lang=js"
import style0 from "./UserControlPreferences.vue?vue&type=style&index=0&id=e8b588ec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports